export default __webpack_public_path__ + "static/media/DNo.13-2.a7f17a47.jpg";